import {useEffect, useState} from "react"

export const useIsOnClient = () => {
    const [isOnClient, setIsOnClient] = useState(false)

    useEffect(() => {
        setIsOnClient(true)
    }, [])

    return {isOnClient}
}
